/* Small, progressively enhanced garden lessons; no tracking or remote calls. */
(() => {
  function setup(scope = document) {
    scope.querySelectorAll('[data-gg-stage-picker]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const buttons = [...root.querySelectorAll('[data-gg-stage]')];
      const panels = [...root.querySelectorAll('[data-gg-stage-panel]')];
      const choose = value => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ggStage === value)));
        panels.forEach(panel => { panel.hidden = panel.dataset.ggStagePanel !== value; });
      };
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.ggStage)));
      choose(buttons[0].dataset.ggStage);
      root.classList.add('is-enhanced');
    });
    scope.querySelectorAll('[data-gg-soil-explorer]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const notes = {
        roots: ['01 · The roots', 'Roots take up water and dissolved nutrients. A comfortable root zone is where good growing begins.'],
        life: ['02 · The soil life', 'Soil organisms help break down organic matter and cycle nutrients. Small things doing a very big job.'],
        habitat: ['03 · The habitat', 'Roots and soil life need air as well as moisture. Check below the surface before reaching for the watering can.']
      };
      root.querySelectorAll('[data-gg-soil-point]').forEach(button => button.addEventListener('click', () => {
        const note = notes[button.dataset.ggSoilPoint];
        root.querySelector('[data-gg-soil-title]').textContent = note[0];
        root.querySelector('[data-gg-soil-copy]').textContent = note[1];
        root.querySelectorAll('[data-gg-soil-point]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();
